/** A scenario type's promotion verdict as a badge; the tooltip says what it rests on. */

import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { readinessDetail, VERDICT_LABELS } from './format';
import type { TypeReadiness, TypeReadinessVerdict } from './types';

const VARIANTS: Record<TypeReadinessVerdict, 'success' | 'destructive' | 'warning' | 'secondary'> = {
	ready: 'success',
	not_ready: 'destructive',
	stale: 'warning',
	no_run: 'secondary'
};

export const ReadinessBadge = ({ readiness, className }: { readiness: TypeReadiness; className?: string }) => (
	<Tooltip>
		<TooltipTrigger asChild>
			<Badge variant={VARIANTS[readiness.verdict]} className={className ?? 'text-[10px]'}>
				{VERDICT_LABELS[readiness.verdict]}
			</Badge>
		</TooltipTrigger>
		<TooltipContent className='max-w-xs'>{readinessDetail(readiness)}</TooltipContent>
	</Tooltip>
);
